import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '@shared/services/notification.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private _notify: NotificationService ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap((event: any) => {
                if (event?.body?.isRefreshNeeded)
                    window.location.reload();
            }),
            catchError((error: any) => {
                // Handle 403 Forbidden with a dedicated message — Generated by Copilot
                if (error?.status === 403) {
                    this._notify.setApiError({ status: 403, message: 'You do not have permission to perform this action.' });
                } else {
                    this._notify.setApiError(error);
                }
                return throwError(() => error);
            })
        );
    }
}